import { createFileRoute } from '@tanstack/react-router'
import { CookiePreferencesPage } from '@/pages/CookiePreferencesPage'

const CookiePreferencesRoute = () => {
  return <CookiePreferencesPage />
}

export const Route = createFileRoute('/cookie-preferences')({
  component: CookiePreferencesRoute,
})
